import {storeID as store, uuid as storeUUID, viewedProduct} from "../store"

export default function setDevModeCredentials() {

    const savedUUID = localStorage.getItem("saved-uuid") || "7a1a5dec-8c69-4574-b79c-d1228f9f534d";
    const savedStoreId = Number(localStorage.getItem("saved-store-id")) || 4655480950;
    const savedProduct = localStorage.getItem("saved-product") || "3927037673590";

        storeUUID.set(savedUUID);
        store.set(savedStoreId);
        viewedProduct.set(savedProduct)

}